import type { RootState } from "@/app/store";

export const selectXPMarket = (state: RootState) => state.xpMarket;
export const selectXPMarketItems = (state: RootState) =>
  state.xpMarket.xpMarketItems;
export const selectXPMarketSort = (state: RootState) =>
  state.xpMarket.xpMarketSort;
export const selectXPMarketSwapTokens = (state: RootState) =>
  state.xpMarket.xpMarketSwapTokens;
export const selectXPMarketItem = (state: RootState) =>
  state.xpMarket.xpMarketItem;
export const selectIsListingXP = (state: RootState) => state.xpMarket.isListXP;
export const selectIsLoadingXPMarketList = (state: RootState) =>
  state.xpMarket.isLoadingXPMarketList;
export const selectIsXPMarketAction = (state: RootState) =>
  state.xpMarket.isXpMarketAction;
